var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divtorotate"}},[_c('svg',{attrs:{"viewBox":"0 0 500 200"}},[_c('path',{staticClass:"svg-stroke",attrs:{"d":"M0,150 C160,-40 350,240 500,55 L660,190 L0,350 Z"}})]),_c('span',{attrs:{"id":"span1"}})])}
var staticRenderFns = []

export { render, staticRenderFns }